/*
 * Copyright (c) 2020 WildFireChat. All rights reserved.
 */

export default class Friend {
    userId;
    alias;
    extra;
    timestamp;
}
